import type { AppModule } from './app-module.types';
import { shellModule } from './shell.module';
import { authModule } from '@/modules/auth/auth.module';
import { usersModule } from '@/modules/users/users.module';
import { catalogModule } from '@/modules/catalog/catalog.module';
import { salesModule } from '@/modules/sales/sales.module';
import { deliveryModule } from '@/modules/delivery/delivery.module';
import { contentModule } from '@/modules/content/content.module';
import { totvsModule } from '@/modules/totvs/totvs.module';
import { guaranteeModule } from '@/modules/guarantee/guarantee.module';
import { notifyModule } from '@/modules/notify/notify.module';
import { pendingAlertsModule } from '@/modules/pending-alerts/pending-alerts.module';
import { filesModule } from '@/modules/files/files.module';

/**
 * Módulo central da aplicação — o equivalente ao `app.module.ts` do NestJS.
 *
 * A única fonte de verdade de "quais módulos existem". Adicionar um módulo =
 * criar sua pasta + `*.module.ts` e acrescentar uma linha aqui. Nada mais no
 * app precisa saber que ele existe: rotas, menu e DI são derivados desta lista
 * (ver `app/bootstrap.ts`, `routes.tsx` e `shared/layout/sidebar.tsx`).
 *
 * A ordem importa para a composição de rotas/menu — `shell` por último para
 * que o catch-all e as páginas genéricas venham depois dos módulos.
 */
export const appModules: AppModule[] = [
  authModule,
  usersModule,
  catalogModule,
  salesModule,
  deliveryModule,
  totvsModule,
  guaranteeModule,
  contentModule,
  notifyModule,
  pendingAlertsModule,
  filesModule,
  shellModule,
];
